<template>
  <div class="page__create_voucher">
    <strong style="font-size: 15px">{{ $t('base.basic_info') }}</strong>
    <br>
    <br>
    <table>
      <tbody>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.type') }}</div>
        </td>
        <td style="width: 480px">
          <div style="margin-top: 20px; display: flex; flex-direction: column; gap: 40px">
            <div style="display: flex; align-items: center">
              <div style="flex: 1">
                <img style="width: 20px; height: 20px"
                     src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Il8yYjZhdnkzenVzdkpWYWMxREJxODhoIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0Ljg3NSA1LjYyNWEyLjE4MyAyLjE4MyAwIDAxLTIuMTg4IDIuMTg4QTIuMTgzIDIuMTgzIDAgMDExMC41IDUuNjI0YTIuMTgzIDIuMTgzIDAgMDEtMi4xODcgMi4xODggMi4xODMgMi4xODMgMCAwMS0yLjE4Ny0yLjE4OCAyLjE4MyAyLjE4MyAwIDAxLTIuMTg4IDIuMTg3IDIuMTc5IDIuMTc5IDAgMDEtMS44My0uOTkgMi4xNzQgMi4xNzQgMCAwMS0uMzU3LTEuMTg1di0uMDEybC42Mi0yLjQ4MUEyLjUgMi41IDAgMDE0Ljc5NiAxLjI1aDExLjQwOGEyLjUgMi41IDAgMDEyLjQyNiAxLjg5NGwuNjIgMi40OFY1LjYzOGEyLjE3NyAyLjE3NyAwIDAxLS4zNTcgMS4xODYgMi4xOCAyLjE4IDAgMDEtMS44My45OSAyLjE4MyAyLjE4MyAwIDAxLTIuMTg4LTIuMTg3ek0zIDguOTMzVjE3LjVjMCAuNjkuNTYgMS4yNSAxLjI1IDEuMjVoMTIuNWMuNjkgMCAxLjI1LS41NiAxLjI1LTEuMjVWOC45MzNhMy40NCAzLjQ0IDAgMDEtMy4xMjUtLjY1NiAzLjQyMyAzLjQyMyAwIDAxLTIuMTg4Ljc4NiAzLjQyMyAzLjQyMyAwIDAxLTIuMTg3LS43ODYgMy40MjQgMy40MjQgMCAwMS0yLjE4OC43ODYgMy40MjMgMy40MjMgMCAwMS0yLjE4Ny0uNzg2QTMuNDQgMy40NCAwIDAxMyA4LjkzM3ptOC4yMDggNi4wNjZhLjU3OS41NzkgMCAwMC0uMjItLjQ4MyAyLjY3NSAyLjY3NSAwIDAwLS43NjgtLjM1NyA3LjI3MyA3LjI3MyAwIDAxLS44OTktLjM1OGMtLjc1OC0uMzcxLTEuMTM3LS44ODItMS4xMzctMS41MzNhMS4zOCAxLjM4IDAgMDEuMjgtLjg1NmMuMjEtLjI2My40ODgtLjQ2My44MDQtLjU3OWEzLjEyMSAzLjEyMSAwIDAxMS4xNjYtLjIwOGMuMzg4LS4wMDYuNzcyLjA3IDEuMTI4LjIyNS4zMTYuMTM0LjU4Ny4zNTcuNzc5LjY0Mi4xODYuMjgxLjI4My42MTIuMjc3Ljk1aC0xLjQwNWEuNzA5LjcwOSAwIDAwLS4yMjItLjU1Ny44NDQuODQ0IDAgMDAtLjU4OS0uMTk1Ljk2Ny45NjcgMCAwMC0uNjA3LjE2OC41MDguNTA4IDAgMDAtLjIxNy40MjIuNTI0LjUyNCAwIDAwLjI0MS40MWMuMjYyLjE2Ny41NDguMjk0Ljg0Ny4zNzcuMzQ2LjEwNC42OC4yNDQuOTk2LjQxNy42MzIuMzY0Ljk0OS44NjYuOTQ5IDEuNTA2YTEuNDMgMS40MyAwIDAxLS41NzkgMS4yMDVjLS4zODUuMjkyLS45MTQuNDM4LTEuNTg2LjQzOGEzLjE4NiAzLjE4NiAwIDAxLTEuMjg5LS4yNTIgMS45NzMgMS45NzMgMCAwMS0uODY4LS43QTEuODM0IDEuODM0IDAgMDE4IDE0LjY1OGgxLjQxNGEuOTEuOTEgMCAwMC4yNDEuNjk1Yy4xNjIuMTQ2LjQyNi4yMi43OTEuMjJhLjkxLjkxIDAgMDAuNTUtLjE1Mi41LjUgMCAwMC4yMTItLjQyMnoiIGZpbGw9IiNFRTREMkQiPjwvcGF0aD48L3N2Zz4="
                     alt=""> &nbsp; {{ $t('voucher.shop_voucher') }}
              </div>
              <div style="flex: 1">
                <el-input type="number" size="mini" class="unset-left" v-model="shop_vouchers">
                  <template slot="prepend">{{ $t('base.quantity') }}</template>
                </el-input>
              </div>
            </div>

            <div style="display: flex; align-items: center">
              <div style="flex: 1">
                <img style="width: 20px; height: 20px;"
                     src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Il8yYjZhdnkzenVzdkpWYWMxREJxODhoIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjYyNSA0LjM3NVY1aC02LjI1di0uNjI1YTMuMTI1IDMuMTI1IDAgMTE2LjI1IDB6TTMuNjIxIDVoMi41MDR2LS42MjVhNC4zNzUgNC4zNzUgMCAxMTguNzUgMFY1aDIuNTAzYTEuMjUgMS4yNSAwIDAxMS4yNDUgMS4xMzhsMS4xMjggMTIuNUExLjI1IDEuMjUgMCAwMTE4LjUwNiAyMEgyLjQ5MmExLjI1IDEuMjUgMCAwMS0xLjI0NS0xLjM2MmwxLjEyOS0xMi41QTEuMjUgMS4yNSAwIDAxMy42MiA1em03LjkxMSA4Ljc1YS43MDUuNzA1IDAgMDEuMDYzLjMyNy42MDcuNjA3IDAgMDEtLjI2LjUxNCAxLjExIDEuMTEgMCAwMS0uNjY5LjE4NWMtLjQ0NCAwLS43NjYtLjA5LS45NjMtLjI2OGExLjExIDEuMTEgMCAwMS0uMjk0LS44NDdINy42ODhjLS4wMDkuNDQxLjExNC44NzUuMzUxIDEuMjQ2LjI2My4zOC42My42NzYgMS4wNTguODUzLjQ5Ni4yMSAxLjAzLjMxNCAxLjU3LjMwNy44MTggMCAxLjQ2Mi0uMTc4IDEuOTMyLS41MzNhMS43NCAxLjc0IDAgMDAuNzA0LTEuNDY4YzAtLjc3OS0uMzg1LTEuMzktMS4xNTYtMS44MzRhNi4zMjIgNi4zMjIgMCAwMC0xLjIxMi0uNTA4IDMuODEyIDMuODEyIDAgMDEtMS4wMzItLjQ1OS42MzguNjM4IDAgMDEtLjI5NC0uNS42MTkuNjE5IDAgMDEuMjY0LS41MTNjLjIxNy0uMTUuNDc3LS4yMjIuNzQtLjIwNS4yNi0uMDE1LjUxNy4wNy43MTcuMjM4YS44NjQuODY0IDAgMDEuMjcuNjc3aDEuNzEyYTIuMDM0IDIuMDM0IDAgMDAtLjMzOC0xLjE1NiAyLjE2NSAyLjE2NSAwIDAwLS45NDktLjc4MiAzLjI5NSAzLjI5NSAwIDAwLTEuMzczLS4yNzMgMy44MDEgMy44MDEgMCAwMC0xLjQyLjI1M2MtLjM4NS4xNC0uNzIzLjM4NC0uOTc4LjcwNGExLjY4IDEuNjggMCAwMC0uMzQyIDEuMDQzYzAgLjc5My40NjEgMS40MTUgMS4zODQgMS44NjcuMzU1LjE3LjcyLjMxNiAxLjA5NS40MzcuMzMzLjA5NC42NDkuMjQuOTM1LjQzNC4wODkuMDcuMTYuMTYuMjA2LjI2MnoiIGZpbGw9IiNFRTREMkQiPjwvcGF0aD48L3N2Zz4="
                     alt=""> &nbsp; {{ $t('voucher.product_voucher') }}
              </div>
              <div style="flex: 1">
                <el-input type="number" size="mini" class="unset-left" v-model="product_vouchers">
                  <template slot="prepend">{{ $t('base.quantity') }}</template>
                </el-input>
              </div>
            </div>

            <div style="display: flex; align-items: center">
              <div style="flex: 1">
                <img style="width: 20px; height: 20px"
                     src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Il8yYjZhdnkzenVzdkpWYWMxREJxODhoIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE5Ljg3NSAzLjc1Yy4zNDUgMCAuNjI1LjI4LjYyNS42MjV2MTEuMjVjMCAuMzQ1LS4yOC42MjUtLjYyNS42MjVIMS4xMjVhLjYyNS42MjUgMCAwMS0uNjI1LS42MjVWMTVhMS4yNSAxLjI1IDAgMDAwLTIuNXYtMS4yNWExLjI1IDEuMjUgMCAwMDAtMi41VjcuNUExLjI1IDEuMjUgMCAwMC41IDV2LS42MjVjMC0uMzQ1LjI4LS42MjUuNjI1LS42MjVoMTguNzV6bS01LjEwMyA3Ljc0NGEuNzgyLjc4MiAwIDAxLjA3LjM2My42NzcuNjc3IDAgMDEtLjI4OC41N2MtLjIyLjE0Ny0uNDguMjE5LS43NDQuMjA2LS40OTQgMC0uODUxLS4xLTEuMDctLjI5OGExLjIzMSAxLjIzMSAwIDAxLS4zMjctLjk0aC0xLjkxMmMtLjAxLjQ5LjEyNi45NzEuMzkgMS4zODQuMjkyLjQyMi43Ljc1IDEuMTc1Ljk0Ny41NTEuMjMzIDEuMTQ1LjM1IDEuNzQ0LjM0MS45MSAwIDEuNjI1LS4xOTcgMi4xNDctLjU5MmExLjkzMiAxLjkzMiAwIDAwLjc4Mi0xLjYzYzAtLjg2Ni0uNDI4LTEuNTQ2LTEuMjg0LTIuMDM5YTcuMDIgNy4wMiAwIDAwLTEuMzQ3LS41NjUgNC4yMzYgNC4yMzYgMCAwMS0xLjE0Ny0uNTEuNzEuNzEgMCAwMS0uMzI2LS41NTQuNjg4LjY4OCAwIDAxLjI5NC0uNTdjLjI0LS4xNjYuNTMtLjI0Ny44MjEtLjIyOS4yOS0uMDE2LjU3NS4wNzkuNzk3LjI2NWEuOTU5Ljk1OSAwIDAxLjMuNzUyaDEuOTAzYTIuMjYgMi4yNiAwIDAwLS4zNzYtMS4yODQgMi40MDYgMi40MDYgMCAwMC0xLjA1NC0uODY5IDMuNjYgMy42NiAwIDAwLTEuNTI3LS4zMDQgNC4yMjQgNC4yMjQgMCAwMC0xLjU3Ny4yODIgMi40ODYgMi40ODYgMCAwMC0xLjA4Ny43ODJjLS4yNTMuMzMzLS4zODYuNzQxLS4zOCAxLjE1OSAwIC44OC41MTMgMS41NzIgMS41MzkgMi4wNzUuMzk0LjE4OC44LjM1IDEuMjE2LjQ4NC4zNy4xMDUuNzIuMjY4IDEuMDQuNDgzYS43ODIuNzgyIDAgMDEuMjI4LjI5ek01LjUgNWgxLjI1djIuNUg1LjVWNXptMCAzLjc1aDEuMjV2Mi41SDUuNXYtMi41em0xLjI1IDMuNzVINS41VjE1aDEuMjV2LTIuNXoiIGZpbGw9IiNFRTREMkQiPjwvcGF0aD48L3N2Zz4="
                     alt=""> &nbsp; {{ $t('voucher.private_voucher') }}
              </div>
              <div style="flex: 1">
                <el-input type="number" size="mini" class="unset-left" v-model="hide_vouchers">
                  <template slot="prepend">{{ $t('base.quantity') }}</template>
                </el-input>
              </div>
            </div>

            <div style="display: flex; align-items: center">
              <div style="flex: 1">
                <img style="width: 20px; height: 20px"
                     src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Il8yYjZhdnkzenVzdkpWYWMxREJxODhoIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1LjIxIDQuMjAzYzAtLjQtLjMyNC0uNzI1LS43MjUtLjcyNUgyLjg5MmMtLjQgMC0uNzI0LjMyNS0uNzI0LjcyNXYxMS41OTRjMCAuNC4zMjQuNzI1LjcyNC43MjVoMTEuNTk1Yy40IDAgLjcyNC0uMzI1LjcyNC0uNzI1VjQuMjAzek02LjUxNCA4LjAxOWMwLS41LjM0Ny0uNjk0Ljc1LS40NWwzLjI5MyAxLjk4NmMuNDEuMjQ3LjQwNC42NTggMCAuOTAybC0zLjI5MyAxLjk3NmMtLjQxMi4yNDQtLjc1LjA0LS43NS0uNDVWOC4wMTl6IiBmaWxsPSIjRUU0RDJEIj48L3BhdGg+PHBhdGggZD0iTTE4LjgzMyAxMi43MDdjMCAuODItLjcwMy45NjctMS4wNzIuNzQybC0xLjgyNi0uOTY1VjcuNTY1bDEuNzgxLTEuMDJjLjM2LS4yMTEgMS4xMS0uMDc0IDEuMTE3Ljc0NXY1LjQxN3oiIGZpbGw9IiNFRTREMkQiPjwvcGF0aD48L3N2Zz4="
                     alt=""> &nbsp; Voucher Shopee Live
              </div>
              <div style="flex: 1">
                <el-input type="number" size="mini" class="unset-left" v-model="shopee_live_vouchers">
                  <template slot="prepend">{{ $t('base.quantity') }}</template>
                </el-input>
              </div>
            </div>

            <div style="display: flex; align-items: center">
              <div style="flex: 1">
                <img style="width: 20px; height: 20px"
                     src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Il8yYjZhdnkzenVzdkpWYWMxREJxODhoIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMzQuNTg0QzUuMjA3LS4wMDggMy44MDcuMTQ5IDIuNzI1LjcwNyAxLjY0IDEuMjY2LjcwOCAyLjMxOS43MDggMy42ODd2MTIuNjI2YzAgMS4zNjguOTMyIDIuNDIgMi4wMTcgMi45OCAxLjA4Mi41NTggMi40ODIuNzE0IDMuNjE1LjEyM2wxMi4xMDUtNi4zMTNjMi40NjItMS4yODQgMi40NjItNC45MjIgMC02LjIwNkw2LjM0LjU4NHptMS40NyAxMy40NDlhMy42MjQgMy42MjQgMCAwMS0uODQxLS4zMDUgNS40ODcgNS40ODcgMCAwMS0uNjMyLS4zODFjLS4xNjUtLjE0LS4zMDYtLjI2MS0uNDItLjM2M2wuNjMtLjg5Ni0uNjMuODk2Yy4xMTQuMTAyLjI1NS4yMjMuNDIuMzYzLjE3OS4xMjcuMzkuMjU0LjYzMi4zOC4yNDIuMTI4LjUyMi4yMy44NDEuMzA2em0tLjg4LS4yMzFhMy43IDMuNyAwIDAwLjg2LjMxMmMuMzI2LjA5LjY5Ny4xMzYgMS4xMS4xMzYuODQzIDAgMS41NDQtLjIwNyAyLjA5Ny0uNjI3LjU2LS40MjUuODM2LTEuMDQzLjgzNi0xLjg0IDAtLjQzMi0uMDk4LS43OTktLjMtMS4wOTVhMi41NDggMi41NDggMCAwMC0uNzUxLS43NDhjLS4zLS4xOTUtLjYzMS0uMzUtLjk5NC0uNDY3YTEzLjY3IDEzLjY3IDAgMDAtMS4wMzctLjMyNkE0LjI5MiA0LjI5MiAwIDAxOC4zNDIgOWEyLjI3OCAyLjI3OCAwIDAxLS40MDMtLjI1NiAxLjIwOCAxLjIwOCAwIDAxLS4yODctLjMyMS43NS43NSAwIDAxLS4xMDMtLjM5NC44MTMuODEzIDAgMDEuNDAxLS42OTRsLjAwMy0uMDAyYy4yNjYtLjE4LjU2Mi0uMjcxLjg5LS4yNzEuNzg5IDAgMS40Ni4xOTMgMi4wMTguNTc2bC4wNjkuMDQ3LjcwNi0xLjAxMi0uMDY3LS4wNDhhNC45MTQgNC45MTQgMCAwMC0xLjIwNi0uNjRjLS40Mi0uMTU3LS45Mi0uMjM0LTEuNTAxLS4yMzRhMi45NzkgMi45NzkgMCAwMC0xLjc5Mi42MDkgMi4zNjEgMi4zNjEgMCAwMC0uNjE0LjczbC0uMDAxLjAwMmMtLjE0Ny4yOC0uMjIuNi0uMjIuOTU0IDAgLjI3NS4wNC41MjYuMTIuNzUzbC4wMDEuMDA0Yy4wOTIuMjIzLjIxLjQyNi4zNTYuNjFsLjAwMi4wMDNhMi43MjcgMi43MjcgMCAwMDEuMDY1Ljc2N2MuMjg0LjExNi41ODcuMjE5LjkwOC4zMDguMzI5LjA4OC42MzIuMTkuOTA5LjMwMi4yNzIuMTExLjQ5MS4yNTIuNjYuNDJsLjAwNS4wMDVjLjE3Mi4xNDguMjU4LjM0LjI1OC41ODNhMS4wMDIgMS4wMDIgMCAwMS0uNDQyLjgzYy0uMjc3LjE5Mi0uNjQ5LjMwMy0xLjEyMy4zMjhhMy4zNzcgMy4zNzcgMCAwMS0xLjIzLS4yMDQgMy40MDUgMy40MDUgMCAwMS0xLjExOC0uNzI2bC0uMDctLjA2Ny0uNzMgMS4wMzYuMDU1LjA1Yy4xMTYuMTAyLjI1Ni4yMjMuNDIzLjM2M2wuMDA1LjAwNGMuMTgyLjEzLjM5Ni4yNi42NC4zODh6IiBmaWxsPSIjRUU0RDJEIj48L3BhdGg+PC9zdmc+"
                     alt=""> &nbsp; Voucher Shopee Video
              </div>
              <div style="flex: 1">
                <el-input type="number" size="mini" class="unset-left" v-model="shopee_video_vouchers">
                  <template slot="prepend">{{ $t('base.quantity') }}</template>
                </el-input>
              </div>
            </div>
          </div>
          <div style="height: 20px"></div>
        </td>
      </tr>
      </tbody>
    </table>

    <table>
      <tbody>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.voucher_name') }}</div>
        </td>
        <td style="width: 500px">
          <br>
          <el-input v-model="form_voucher.name" style="width: 96%" size="mini"
                    :placeholder="$t('input.voucher_name')"></el-input>
        </td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td><span style="color: #666; font-size: 12px">{{ $t('voucher.visible_to_buyers') }}</span></td>
      </tr>
      <tr v-if="['shop', 'product', 'hide'].includes(type)">
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.code') }}</div>
        </td>
        <td>
          <br>
          <div>

            <el-radio v-model="gen_voucher_type" label="auto">{{ $t('voucher.gen_code_auto') }}</el-radio>
            <div>
              <span style="color: #666; font-size: 12px">{{ $t('voucher.create_auto_by_atosa') }}</span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td>
        </td>
      </tr>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.usage_period') }}</div>
        </td>
        <td>
          <br>
          <el-date-picker
            style="width: 24%;"
            size="mini"
            type="date"
            :placeholder="$t('select.start_time')"
            v-model="form_voucher.start_time"
            :clearable="false">
          </el-date-picker>
          <el-time-picker
            style="width: 20%;"
            size="mini"
            :placeholder="$t('select.hour')"
            format="HH:mm"
            v-model="form_voucher.el_start_time"
            :clearable="false">
          </el-time-picker>
          <div style="display: inline-block; width: 5%; text-align: center">-</div>
          <el-date-picker
            style="width: 24%"
            size="mini"
            type="date"
            :placeholder="$t('select.end_time')"
            v-model="form_voucher.end_time"
            :clearable="false">
          </el-date-picker>
          <el-time-picker
            style="width: 20%;"
            size="mini"
            :placeholder="$t('select.hour')"
            format="HH:mm"
            v-model="form_voucher.el_end_time"
            :clearable="false">
          </el-time-picker>
        </td>
      </tr>
      </tbody>
    </table>
    <br>
    <br>

    <div style="display: flex; align-items: center; margin-top: 30px">
      <div style="width: 260px">
        <strong style="font-size: 15px">{{ $t('voucher.reward_settings') }}</strong>
      </div>
      <div class="text-right" style="width: 500px; padding-right: 20px">
        <el-button type="primary" size="mini" @click="show_dialog.select_template = true">
          {{ $t('voucher.select_settings_template') }}
        </el-button>
      </div>
    </div>
    <br>
    <br>
    <table>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.reward_type') }}</div>
        </td>
        <td>
          <div style="width: 500px; padding-top: 7px">
            <el-radio v-model="form_voucher.rule.reward_type" size="small" :label="0">
              {{ $t('base.discount') }}
            </el-radio>
            <el-radio v-model="form_voucher.rule.reward_type" size="small" :label="1">{{
                $t('voucher.coin_cashback')
              }}
            </el-radio>
          </div>
        </td>
      </tr>
      <template v-if="form_voucher.rule.reward_type === 0">
        <tr>
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
            <br>
            <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.discount_type') }} |
              {{ $t('voucher.amount') }}
            </div>
          </td>
          <td>
            <br>
            <div>
              <el-select style="width: 30%" size="mini" value="" v-model="v_or_d">
                <el-option value="v" :label="$t('voucher.by_amount')"></el-option>
                <el-option value="d" :label="$t('voucher.by_percent')"></el-option>
              </el-select>
              <div style="display: inline-block; width: 5%"></div>
              <el-input v-model="form_voucher.value" class="unset-left" v-if="v_or_d === 'v'" type="number" size="mini"
                        :max="120000000" style="width: 60%" :placeholder="$t('input.amount')">
                <template slot="prepend">đ</template>
              </el-input>
              <el-input v-model="form_voucher.discount" class="unset-left" v-if="v_or_d === 'd'" type="number"
                        size="mini" style="width: 60%" :placeholder="$t('input.percent')">
                <template slot="prepend">%</template>
              </el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          </td>
          <td>
            <div style="text-align: right; padding-right: 20px">
              <span style="font-size: 12px; color: red"
                    v-if="v_or_d === 'v'">{{ $t('voucher.by_amount') }}: {{ form_voucher.value | currency }}</span>
              <span style="font-size: 12px; color: red"
                    v-if="v_or_d === 'd'">{{ $t('voucher.by_percent') }}: {{ form_voucher.discount }}%</span>
            </div>
          </td>
        </tr>
      </template>
      <template v-if="form_voucher.rule.reward_type === 1">
        <tr>
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
            <br>
            <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.discount_type') }} |
              {{ $t('voucher.amount') }}
            </div>
          </td>
          <td>
            <br>
            <div>
              <el-select style="width: 30%" size="mini" value="d">
                <el-option value="d" :label="$t('voucher.by_percent')"></el-option>
              </el-select>
              <div style="display: inline-block; width: 5%"></div>
              <el-input v-model="form_voucher.rule.coin_cashback_voucher.coin_percentage_real" class="unset-left"
                        type="number" size="mini" style="width: 60%" :placeholder="$t('input.percent')">
                <template slot="prepend">% {{ $t('voucher.coin_cashback') }}</template>
              </el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
          <span style="font-size: 12px; color: #666">
              {{
              $t('voucher.will_be_returned_message', {x: +form_voucher.rule.coin_cashback_voucher.coin_percentage_real ? form_voucher.rule.coin_cashback_voucher.coin_percentage_real : '-'})
            }}.
            </span>
          </td>
        </tr>
      </template>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;"> {{ $t('voucher.min_basket_price') }}</div>
        </td>
        <td>
          <br>
          <div>
            <el-input v-model="form_voucher.min_price" type="number" size="mini" style="width: 96%"
                      :placeholder="$t('input.value')"></el-input>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
        </td>
        <td>
          <div style="text-align: right; padding-right: 20px">
            <span style="font-size: 12px; color: red">{{ $t('base.value') }}: {{
                form_voucher.min_price | currency
              }}</span>
          </div>
        </td>
      </tr>
      <template v-if="form_voucher.rule.reward_type === 0 && this.v_or_d === 'd'">
        <tr>
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
            <br>
            <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.max_capped_amount') }}</div>
          </td>
          <td>
            <br>
            <div style="padding-top: 7px">
              <el-radio v-model="is_limit_0" label="y">{{ $t('base.limited') }}</el-radio>
              <el-radio v-model="is_limit_0" label="n">{{ $t('base.unlimited') }}</el-radio>
            </div>
          </td>
        </tr>
        <tr v-if="is_limit_0 === 'y'">
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          </td>
          <td>
            <el-input v-model="form_voucher.max_value" type="number" size="mini" style="width: 96%"
                      :placeholder="$t('input.value')"></el-input>
            <div style="height: 10px"></div>
          </td>
        </tr>
        <tr v-if="is_limit_0 === 'y'">
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          </td>
          <td>
            <div style="text-align: right; padding-right: 20px">
              <span style="font-size: 12px; color: red">{{ $t('base.value') }}: {{
                  form_voucher.max_value | currency
                }}</span>
            </div>
          </td>
        </tr>
      </template>
      <template v-if="form_voucher.rule.reward_type === 1">
        <tr>
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
            <br>
            <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.max_capped_amount') }}</div>
          </td>
          <td>
            <br>
            <div style="padding-top: 7px">
              <el-radio v-model="is_limit_1" label="y">{{ $t('base.limited') }}</el-radio>
              <el-radio v-model="is_limit_1" label="n">{{ $t('base.unlimited') }}</el-radio>
            </div>
          </td>
        </tr>
        <tr v-if="is_limit_1 === 'y'">
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          </td>
          <td>
            <el-input v-model="form_voucher.rule.coin_cashback_voucher.max_coin" type="number" size="mini"
                      style="width: 96%"
                      :placeholder="$t('input.value')"></el-input>
            <span style="font-size: 12px; color: #666">{{ $t('voucher.equals_to') }}:</span>
            <strong
              style="font-size: 12px; color: #666">{{
                +form_voucher.rule.coin_cashback_voucher.max_coin ? form_voucher.rule.coin_cashback_voucher.max_coin : '-'
              }}
              Shopee {{ $t('voucher.coins') }}</strong>
          </td>
        </tr>
        <tr v-if="is_limit_1 === 'y'">
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          </td>
          <td>
            <div style="text-align: right; padding-right: 20px">
              <span style="font-size: 12px; color: red">{{ $t('base.value') }}: {{
                  form_voucher.rule.coin_cashback_voucher.max_coin | currency
                }}</span>
            </div>
          </td>
        </tr>
      </template>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.max_usage_quantity') }}</div>
        </td>
        <td>
          <br>
          <div>
            <el-input v-model="form_voucher.usage_quantity" type="number" size="mini" style="width: 96%"
                      :placeholder="$t('input.value')"></el-input>
          </div>
        </td>
      </tr>
      <tr v-if="['shop', 'product', 'hide'].includes(this.type)">
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.max_distribution') }}</div>
        </td>
        <td>
          <br>
          <div>
            <el-input v-model="form_voucher.rule.usage_limit_per_user" type="number" size="mini" style="width: 96%"
                      :placeholder="$t('input.value')"></el-input>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          &nbsp;
        </td>
        <td style="text-align: right;">
          <br>
          <br>
          <el-button type="primary" size="mini" @click="show_dialog.create_voucher_template = true"
                     style="margin-right: 20px">
            {{ $t('voucher.save_settings_template') }}
          </el-button>
        </td>
      </tr>
    </table>
    <br>
    <br>

    <strong style="font-size: 15px">{{ $t('voucher.voucher_display_title') }}</strong>
    <br>
    <br>
    <table>
      <tr v-if="['shop', 'product'].includes(this.type)">
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.display_setting') }}</div>
        </td>
        <td>
          <div style="width: 500px; padding-top: 7px">
            <el-radio v-model="form_voucher.rule.voucher_landing_page" :label="1">{{
                $t('voucher.display_on_all_pages')
              }}
            </el-radio>
            <el-radio v-model="form_voucher.rule.voucher_landing_page" :label="0">{{
                $t('voucher.shared_through_code')
              }}
            </el-radio>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">
            {{ $t('voucher.applicable_products') }}
            <template v-if="['hide', 'shopee_live', 'shopee_video'].includes(type)">
              <br><span class="text-danger">({{ $t('base.not_required') }})</span>
            </template>
          </div>
        </td>
        <td>
          <div style="width: 500px;">
            <br>
            <template v-if="type === 'shop'">
              <span style="font-size: 14px">{{ $t('product.all') }}</span>
            </template>
            <template v-else>
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="show_dialog.select_product = true">
                {{ $t('base.add_products') }}
              </el-button>
              <el-button type="info" size="mini" @click="m__show_selected_product">
                {{ $t('voucher.show_selected_products') }} ({{ form_voucher.rule.items.length }}
                {{ $t('base.products') }})
              </el-button>
            </template>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
        </td>
        <td>
          <div style="width: 500px; text-align: right; padding-right: 20px">
            <br>
            <br>
            <br>
            <el-button type="info" size="mini" icon="el-icon-refresh" @click="form_voucher = clone(temp)">Refresh
            </el-button>
            <el-button v-if="update_file_id" type="primary" size="mini" icon="el-icon-check"
                       :loading="loading.create_voucher">
              {{ $t('base.update_file') }}
            </el-button>
            <el-button v-else type="primary" size="mini" icon="el-icon-check" :loading="loading.create_voucher"
                       @click="m__create_voucher">
              {{ $t('voucher.confirm_and_create') }}
            </el-button>
          </div>
        </td>
      </tr>
    </table>

    <el-dialog width="1300px" :close-on-click-modal="false" :visible.sync="show_dialog.selected_list"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-table :data="product_selected_list">
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                   style="width:35px; height: 35px;"> &nbsp;&nbsp;&nbsp; {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.sold')" prop="sold" width="130px" sortable>
            <template slot-scope="scope">{{ scope.row.sold | currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="130px" sortable>
            <template slot-scope="scope">{{ scope.row.price | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable>
            <template slot-scope="scope">{{ scope.row.revenue | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="130px" sortable>
            <template slot-scope="scope">{{ scope.row.stock | currency }}</template>
          </el-table-column>
          <el-table-column :prop="$t('base.action')" width="100px">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="m__remove_selected_product(scope.row.itemid)">
                <strong class="text-danger">{{ $t('base.delete') }}</strong>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog width="1300px" :close-on-click-modal="false" :visible.sync="show_dialog.select_product"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row type="margin-top: 10px">
          <el-col :sm="12">
            <p v-if="loading_product"><span class="el-icon-loading"></span>
              <strong style="font-size: 18px" class="text-danger">
                {{ $t('base.loading_products') }}</strong></p>
            <p v-else><strong style="font-size: 18px">{{ $t('select.products') }}
              <a href="javascript:void(0)" @click="m__get_product()">({{ $t('base.update') }})</a></strong></p>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input type="text" size="mini" v-model="product_filter.keyword" style="width: 300px"
                      :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change">
          <el-table-column width="40px" fixed="left" label="#">
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.selected"
                           :disabled="product_selected_list.length >= 10"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                   style="width:35px; height: 35px;"> &nbsp;&nbsp;&nbsp; {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.sold')" prop="sold" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.sold | currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.price | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.revenue | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.stock | currency }}</template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="prev, pager, next, total" :total="c__product_filter_list.length"/>

        <el-row style="margin-top: 15px">
          <el-col :sm="12">
            <el-checkbox size="mini" v-model="product_filter.available">{{
                $t('base.show_eligible_products_only')
              }}
            </el-checkbox>
          </el-col>
          <el-col :sm="12" class="text-right">
            <small>{{ $t('base.selected') }} <span
              style="color: orangered">{{ product_list.filter(i => i.selected).length }}</span> /
              <span
                style="color: orangered">{{ c__product_filter_list.length }}</span> {{ $t('base.products') }}</small>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_select_product"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="600px" :close-on-click-modal="false" :visible.sync="show_dialog.select_template"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('voucher.settings_template') }}</strong>

        <div style="margin-top: 30px">
          <el-table :data="voucher_templates">
            <el-table-column :label="$t('voucher.template_name')" prop="name"></el-table-column>
            <el-table-column :label="$t('base.optional')" width="120px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__use_voucher_template(scope.row)">
                  <strong class="text-primary">{{ $t('base.use') }}</strong>
                </el-button>
                <el-button v-if="scope.row._id" type="text" size="mini" @click="m__use_voucher_template(scope.row)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="600px" :close-on-click-modal="false" :visible.sync="show_dialog.gen_voucher_code"
               custom-class="no-body">
      <div slot="title" style="padding: 10px 10px 10px 20px;">
        <strong class="strong-title">{{ $t('voucher.gen_code_auto') }}</strong>

        <div style="margin-top: 30px">
          <div style="display: flex; align-items: center">
            <div style="flex: 2; display: flex; flex-direction: column; gap: 20px">
              <el-radio v-model="gen_type" label="AMMYY">{{ $t('base.format') }} AMMYY</el-radio>
              <el-radio v-model="gen_type" label="MMYYA">{{ $t('base.format') }} MMYYA</el-radio>
              <el-radio v-model="gen_type" label="AAADD">{{ $t('base.format') }} AAADD</el-radio>
              <el-radio v-model="gen_type" label="DDDAA">{{ $t('base.format') }} DDDAA</el-radio>
              <div>
                <el-radio v-model="gen_type" label="custom">{{ $t('voucher.custom') }}</el-radio>
                <el-input v-if="gen_type === 'custom'" v-model="auto_voucher_custom" size="mini" style="width: 200px"
                          maxlength="5" show-word-limit :placeholder="$t('input.format')"></el-input>
              </div>
            </div>
            <div style="flex: 1; line-height: 30px">
              MM = {{ $t('base.month') }}
              <br>
              YY = {{ $t('base.year') }}
              <br>
              A = {{ $t('base.letter') }}
              <br>
              D = {{ $t('base.digit') }}
            </div>
          </div>
        </div>

        <div style="margin-top: 50px; display: flex; align-items: center">
          <el-button type="primary" size="mini" style="margin-left: 10px" @click="m__gen_voucher_code(gen_type)">
            {{ $t('voucher.gen_code') }}
          </el-button>
          <div v-if="auto_voucher_code" style="padding-left: 50px; display: flex; gap: 5px; align-items: center">
            <strong style="font-size: 14px">{{ auto_voucher_code }}</strong>
            <i style="cursor: pointer; font-size: 14px !important;" class="el-icon-copy-document"
               @click="copy_text(auto_voucher_code); form_voucher.voucher_code = auto_voucher_code; show_dialog.gen_voucher_code = false"></i>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.create_voucher_template" :close-on-click-modal="false" custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('voucher.template_name') }}</p>
        <el-input size="mini" :placeholer="$t('input.template_name')" v-model="voucher_template_name"></el-input>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.create_voucher_template"
                     @click="m__create_voucher_template()">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//import dayjs from 'dayjs'
import {drop as _drop, orderBy as _orderBy, take as _take} from 'lodash'

export default {
  name: 'page__create_voucher',

  props: {
    shop: {},
    seller: {},
    product_list: {
      type: Array,
      default: []
    },
    selected_product_ids: {
      type: Array,
      default: []
    },
    loading_product: {
      type: Boolean,
      default: false
    },
    copy_from_id: null,
    copy_from_file: null,
    has_new_voucher: false,
    voucher_list: {
      type: Array,
      default: []
    },
    update_file_id: null
  },

  data() {
    return {
      prefix: '',
      type: 'shop',
      v_or_d: 'v',
      is_limit_0: 'n',
      is_limit_1: 'n',
      temp: {
        name: '',
        voucher_code: '',
        start_time: this.dayjs().add(10, 'm').toDate(),
        el_start_time: this.dayjs().add(10, 'm').toDate(),
        end_time: this.dayjs().add(10, 'h').toDate(),
        el_end_time: this.dayjs().add(10, 'h').toDate(),
        rule: {
          backend_created: 0,
          voucher_landing_page: 1,
          hide: 0,
          items: [],
          reward_type: 0,
          coin_cashback_voucher: {
            coin_percentage_real: null,
            max_coin: null
          },
          display_from: null,
          exclusive_channel_type: null,
          usage_limit_per_user: 1,
          display_voucher_early: false,
          choose_users: {
            shop_order_count: 0,
            shop_order_count_period: 0
          }
        },
        usage_quantity: 10,
        value: null,
        discount: null,
        max_value: null,
        min_price: null
      },
      form_voucher: {},
      loading: {
        create_voucher: false,
        create_voucher_template: false
      },
      show_dialog: {
        select_product: false,
        selected_list: false,
        select_template: false,
        gen_voucher_code: false,
        create_voucher_template: false
      },
      product_selected_list: [],
      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        available: true
      },
      product_sort_option: {
        order: null,
        prop: null
      },
      detail_voucher: null,

      voucher_templates: [
        {
          name: this.$t('voucher.template_name_1'),
          v_or_d: 'v',
          value: 500000,
          discount: null,
          min_price: 0,
          usage_quantity: 1,
          is_limit_0: 'n',
          max_value: null,
          reward_type: 0
        },
        {
          name: this.$t('voucher.template_name_2'),
          v_or_d: 'v',
          value: 200000,
          discount: null,
          min_price: 0,
          usage_quantity: 3,
          is_limit_0: 'n',
          max_value: null,
          reward_type: 0
        },
        {
          name: this.$t('voucher.template_name_3'),
          v_or_d: 'v',
          value: 100000,
          discount: null,
          min_price: 0,
          usage_quantity: 5,
          is_limit_0: 'n',
          max_value: null,
          reward_type: 0
        },
        {
          name: this.$t('voucher.template_name_4'),
          v_or_d: 'v',
          value: 50000,
          discount: null,
          min_price: 0,
          usage_quantity: 10,
          is_limit_0: 'n',
          max_value: null,
          reward_type: 0
        },
        {
          name: this.$t('voucher.template_name_5'),
          v_or_d: 'd',
          discount: 5,
          value: null,
          min_price: 100000,
          usage_quantity: 100,
          is_limit_0: 'y',
          max_value: 15000,
          reward_type: 0
        },
        {
          name: this.$t('voucher.template_name_6'),
          v_or_d: 'd',
          discount: 25,
          value: null,
          min_price: 150000,
          usage_quantity: 100,
          is_limit_0: 'y',
          max_value: 25000,
          reward_type: 0
        }
      ],

      gen_type: 'AMMYY',
      auto_voucher_code: '',
      auto_voucher_custom: '',

      shop_vouchers: 0,
      product_vouchers: 0,
      hide_vouchers: 0,
      shopee_live_vouchers: 0,
      shopee_video_vouchers: 0,

      voucher_template_name: '',

      gen_voucher_type: 'auto'
    }
  },

  async beforeMount() {
    this.form_voucher = this.clone(this.temp)

    if (this.copy_from_id) {
      const response = await this.seller.marketing_get_voucher_detail(this.copy_from_id)
      if (response && response.data && response.data.data) {
        const voucher = response.data.data
        console.log('voucher', voucher)
        this.form_voucher.name = voucher.name
        this.form_voucher.min_price = +voucher.min_price
        this.form_voucher.max_price = +voucher.max_price
        this.form_voucher.value = +voucher.value
        this.form_voucher.discount = +voucher.discount
        if (voucher.value) {
          this.v_or_d = 'd'
        }

        const second_diff = this.dayjs(voucher.end_time * 1000).diff(voucher.start_time * 1000, 'second')
        this.form_voucher.start_time = new Date()
        this.form_voucher.end_time = this.dayjs().add(second_diff, 'second')

        if (voucher.voucher_code.startsWith('VIDEO')) {
          this.type = 'shopee_video'
        } else if (voucher.voucher_code.startsWith('LIVE')) {
          this.type = 'shopee_live'
        } else {
          if (voucher.rule.hide) {
            this.type = 'hide'
          } else {
            if (voucher.rule.shopids) {
              this.type = 'shop'
            } else {
              this.type = 'product'
            }
          }
        }

        for (const key of Object.keys(this.temp.rule)) {
          this.form_voucher.rule[key] = voucher.rule[key] || this.temp.rule[key]
        }
      }
    }

    if (this.copy_from_file) {
      const voucher = this.clone(this.copy_from_file.data)
      console.log(voucher)

      this.form_voucher.name = voucher.name
      this.form_voucher.min_price = +voucher.min_price
      this.form_voucher.max_price = +voucher.max_price
      this.form_voucher.value = +voucher.value

      const second_diff = this.dayjs(voucher.end_time * 1000).diff(voucher.start_time * 1000, 'second')
      this.form_voucher.start_time = new Date()
      this.form_voucher.end_time = this.dayjs().add(second_diff, 'second')

      if (voucher.voucher_code.startsWith('VIDEO')) {
        this.type = 'shopee_video'
      } else if (voucher.voucher_code.startsWith('LIVE')) {
        this.type = 'shopee_live'
      } else {
        if (voucher.rule.hide) {
          this.type = 'hide'
        } else {
          if (voucher.rule.shopids) {
            this.type = 'shop'
          } else {
            this.type = 'product'
          }
        }
      }

      for (const key of Object.keys(this.temp.rule)) {
        this.form_voucher.rule[key] = voucher.rule[key] || this.temp.rule[key]
      }
    }

    this.prefix = this.shop.username.split('').filter(i => /[a-z0-9]/ig.test(i)).slice(0, 4).join('').toUpperCase()

    if (this.selected_product_ids && this.selected_product_ids.length) {
      this.form_voucher.rule.items = this.selected_product_ids.map(i => ({itemid: +i}))
      this.type = 'product'
    }

    await this.m__get_voucher_template()
    await this.m__get_product()
  },

  watch: {
    'form_voucher.rule.usage_limit_per_user': function () {
      if (this.form_voucher.rule.usage_limit_per_user > 5) {
        this.form_voucher.rule.usage_limit_per_user = 5
      }
    }
  },

  computed: {
    c__product_filter_list() {
      let result = this.product_list

      if (this.product_filter.available) {
        result = result.filter(i => i.stock > 0)
      }

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      result = result.filter(i => this.form_voucher.rule.items && !this.form_voucher.rule.items.some(ii => ii.itemid === i.itemid))

      const words = this.remove_unicode(this.product_filter.keyword)
      return result.filter(item => this.remove_unicode(item.name).includes(words))
    },

    c__product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)
      return _take(_drop(this.c__product_filter_list, skip), limit)
    }
  },

  methods: {
    async m__get_voucher_template() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/voucher_template/get', {}, this.cf())
      for (const item of response.body.data) {
        this.voucher_templates.push({
          _id: item._id,
          name: item.filename,
          ...item.data
        })
      }
    },

    async m__create_voucher_template() {
      if (!this.voucher_template_name) {
        this.ntf_w(this.$t('required.template_name'))
        return
      }

      this.loading.create_voucher_template = true

      // this.v_or_d = template.v_or_d
      // this.form_voucher.value = template.value
      // this.form_voucher.min_price = template.min_price
      // this.form_voucher.discount = template.discount
      // this.form_voucher.usage_quantity = template.usage_quantity
      // this.is_limit_0 = template.is_limit_0
      // this.form_voucher.max_value = template.max_value
      // this.form_voucher.rule.reward_type = template.reward_type

      const form = {
        filename: this.voucher_template_name,
        data: {
          v_or_d: this.v_or_d,
          value: this.form_voucher.value,
          min_price: this.form_voucher.min_price,
          discount: this.form_voucher.discount,
          usage_quantity: this.form_voucher.usage_quantity,
          is_limit_0: this.is_limit_0,
          max_value: this.form_voucher.max_value,
          reward_type: this.form_voucher.rule.reward_type
        },
        shop_id: this.shop._id
      }
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/voucher_template/create', form, this.cf())
      await this.m__get_voucher_template()
      this.loading.create_voucher_template = false
      this.show_dialog.create_voucher_template = false
      this.$t('base.save_success')
    },

    m__gen_voucher_code() {
      const format = this.gen_type === 'custom'
        ? this.auto_voucher_custom
        : this.gen_type

      if (!format) return

      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const random_letter = () => letters[Math.floor(Math.random() * letters.length)]
      const random_digit = () => Math.floor(Math.random() * 10)
      const current_month = this.dayjs().format('MM')
      const current_year = this.dayjs().format('YY')

      this.auto_voucher_code = format
        .replace(/A/g, random_letter)
        .replace(/D/g, random_digit)
        .replace(/MM/g, current_month)
        .replace(/YY/g, current_year)

      console.log(this.auto_voucher_code)
    },

    m__use_voucher_template(template) {
      this.v_or_d = template.v_or_d
      this.form_voucher.value = template.value
      this.form_voucher.min_price = template.min_price
      this.form_voucher.discount = template.discount
      this.form_voucher.usage_quantity = template.usage_quantity
      this.is_limit_0 = template.is_limit_0
      this.form_voucher.max_value = template.max_value
      this.form_voucher.rule.reward_type = template.reward_type

      this.show_dialog.select_template = false
    },

    m__validate_voucher_code() {
      this.form_voucher.voucher_code = this.form_voucher.voucher_code.split('').filter(i => /[a-z0-9]/ig.test(i)).join('').toUpperCase()
    },

    async m__create_voucher() {
      this.loading.create_voucher = true

      try {
        if (!this.form_voucher.name) {
          this.ntf_w(this.$t('required.voucher_name'))
          return
        }
        if (!this.form_voucher.start_time) {
          this.ntf_w(this.$t('required.start_time'))
          return
        }
        if (!this.form_voucher.start_time) {
          this.ntf_w(this.$t('required.start_time'))
          return
        }
        if (!this.form_voucher.end_time) {
          this.ntf_w(this.$t('required.end_time'))
          return
        }

        this.form_voucher.start_time = this.dayjs(this.form_voucher.start_time).hour(this.dayjs(this.form_voucher.el_start_time).hour()).toDate()
        this.form_voucher.start_time = this.dayjs(this.form_voucher.start_time).minute(this.dayjs(this.form_voucher.el_start_time).minute()).toDate()
        this.form_voucher.end_time = this.dayjs(this.form_voucher.end_time).hour(this.dayjs(this.form_voucher.el_end_time).hour()).toDate()
        this.form_voucher.end_time = this.dayjs(this.form_voucher.end_time).minute(this.dayjs(this.form_voucher.el_end_time).minute()).toDate()
        if (Math.floor(new Date(this.form_voucher.end_time).getTime() / 1000) - Math.floor(new Date(this.form_voucher.start_time).getTime() / 1000) < 3600) {
          this.ntf_w(this.$t('voucher.at_least_1_day'))
          return
        }

        if (this.form_voucher.rule.reward_type === 0) {
          if (this.v_or_d === 'v' && !this.form_voucher.value) {
            this.ntf_w(this.$t('required.discount_price'))
            return
          }
          if (this.v_or_d === 'v' && +this.form_voucher.discount > +this.form_voucher.min_price) {
            this.ntf_w(this.$t('voucher.discount_gt_min'))
            return
          }
          if (this.v_or_d === 'd' && !this.form_voucher.discount) {
            this.ntf_w(this.$t('required.discount_percent'))
            return
          }
          if (this.is_limit_0 === 'y' && !this.form_voucher.max_value) {
            this.ntf_w(this.$t('voucher.required_max_capped_amount'))
            return
          }
        }

        if (this.form_voucher.rule.reward_type === 1) {
          if (!this.form_voucher.rule.coin_cashback_voucher.coin_percentage_real) {
            this.ntf_w(this.$t('voucher.required_coin_cashback'))
          }
          if (this.is_limit_1 === 'y' && !this.form_voucher.rule.coin_cashback_voucher.max_coin) {
            this.ntf_w(this.$t('voucher.required_max_coin_cashback'))
            return
          }
        }

        if (!this.form_voucher.usage_quantity) {
          this.ntf_w(this.$t('voucher.required_usage_quantity'))
          return
        }
        if (this.type === 'product' && !this.form_voucher.rule.items.length) {
          this.ntf_w(this.$t('required.select_products'))
          return
        }

        // shop_vouchers: 0,
        //   product_vouchers: 0,
        //   hide_vouchers: 0,
        //   shopee_live_vouchers: 0,
        //   shopee_video_vouchers: 0,

        const keys = ['shop_vouchers', 'product_vouchers', 'hide_vouchers', 'shopee_live_vouchers', 'shopee_video_vouchers']
        for (const key of keys) {
          if (!+this[key]) continue

          for (let i = 0; i < +this[key]; i++) {
            this.gen_type = 'custom'
            this.auto_voucher_custom = 'AAADD'
            this.m__gen_voucher_code()

            // TODO: format
            const form = this.clone(this.form_voucher)

            let prefix_name = ''
            if (key === 'shop_vouchers') prefix_name = `${this.$t('voucher.shop_voucher')} - `
            if (key === 'product_vouchers') prefix_name = `${this.$t('voucher.product_voucher')} - `
            if (key === 'hide_vouchers') prefix_name = `${this.$t('voucher.private_voucher')} - `
            if (key === 'shopee_live_vouchers') prefix_name = 'Voucher shopee live - '
            if (key === 'shopee_video_vouchers') prefix_name = 'Voucher shopee video - '

            form.name = prefix_name + form.name
            form.voucher_code = this.prefix + this.auto_voucher_code

            if (key === 'shop_vouchers') {
              form.rule.items = []
            }

            if (this.dayjs(new Date(form.start_time)).isBefore(this.dayjs(), 's')) {
              form.start_time = this.dayjs().unix()
            } else {
              form.start_time = Math.floor(new Date(form.start_time).getTime() / 1000)
            }

            if (this.dayjs(new Date(form.end_time)).isBefore(this.dayjs(), 's')) {
              form.end_time = this.dayjs().add(1, 'd').unix()
            } else {
              form.end_time = Math.floor(new Date(form.end_time).getTime() / 1000)
            }

            if (form.rule.reward_type === 0) {
              form.rule.coin_cashback_voucher.coin_percentage_real = null
              form.rule.coin_cashback_voucher.max_coin = null

              if (this.v_or_d === 'v') {
                form.value = +form.value
                form.discount = null
                form.max_value = null
                this.is_limit_0 = 'n'
              } else {
                form.value = null
                form.discount = +form.discount
              }
              if (this.is_limit_0 === 'y') {
                form.max_value = +form.max_value
              } else {
                form.max_value = null
              }
            }

            if (form.rule.reward_type === 1) {
              form.max_value = form.discount = form.value = null

              form.rule.coin_cashback_voucher.coin_percentage_real = +form.rule.coin_cashback_voucher.coin_percentage_real
              if (this.is_limit_1 === 'y') {
                form.rule.coin_cashback_voucher.max_coin = +form.rule.coin_cashback_voucher.max_coin
              } else {
                form.rule.coin_cashback_voucher.max_coin = null
              }
            }

            if (form.rule.voucher_landing_page === 1) {
              form.rule.hide = 0
            } else {
              form.rule.hide = 1
            }

            if (key === 'hide_vouchers') {
              form.rule.hide = 1
            }
            if (key === 'shopee_live_vouchers') {
              form.rule.exclusive_channel_type = 1
              form.voucher_code = null
            }
            if (key === 'shopee_video_vouchers') {
              form.rule.exclusive_channel_type = 2
              form.voucher_code = null
            }

            form.min_price = +form.min_price || 0
            form.usage_quantity = +form.usage_quantity

            form.rule.usage_limit_per_user = +form.rule.usage_limit_per_user

            console.log(form)
            const resp = await this.seller.marketing_create_voucher(form)
            console.log(resp.data)
          }
        }
        this.ntf_s(this.$t('voucher.create_success'))
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.create_voucher = false
      }
    },

    m__product_sort_change({
                             prop,
                             order
                           }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    m__get_product() {
      this.$emit('m__get_product')
    },

    m__confirm_select_product() {
      this.form_voucher.rule.items = this.c__product_filter_list.filter(i => i.selected).map(i => ({itemid: i.itemid}))
      this.show_dialog.select_product = false
    },

    m__show_selected_product() {
      this.product_selected_list = []

      for (const item of this.form_voucher.rule.items) {
        const product_found = this.product_list.find(i => i.itemid === item.itemid)
        if (product_found) this.product_selected_list.push(product_found)
      }
      this.show_dialog.selected_list = true
    },

    m__remove_selected_product(item_id) {
      this.product_selected_list = this.product_selected_list.filter(i => i.itemid !== item_id)
      this.form_voucher.rule.items = this.form_voucher.rule.items.filter(i => i.itemid !== item_id)
    }
  }
}
</script>

<style>
.unset-left input {
  border-left: none !important;
  border-top-left-radius: unset !important;
  border-bottom-left-radius: unset !important;
}

.unset-left .el-input-group__prepend {
  border: 1px solid #c0c4cc;
}

.page__create_voucher table td {
  padding: 5px 0 !important;
}

.page__create_voucher input {
  padding-right: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/voucher/create_multi.vue